import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import PromoCards from 'Pods/SearchPage/Shared/PromoCards/PromoCards'
import { rememberAssetType } from 'Pods/SearchPage/Shared/RememberedAssetType/rememberedAssetType'
import { FILTER_NAME, PROMO_SLOT, SELECTION_METHOD } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect, useTrackResetClick } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearAllFilters } from 'Pods/SearchPage/Store/actions'
import { setAssetType } from 'Pods/SearchPage/Store/actions/assetType'
import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import { getFiltersCount } from 'Pods/SearchPage/Store/selectors'

function EmptyState() {
  const translate = useTranslate()
  const hasFilters = useSearchPageStore(state => getFiltersCount(state) > 0)
  const isTypeSelected = useSearchPageStore(state => state.assetType !== ASSET_TYPE.ALL)
  const trackResetClick = useTrackResetClick()
  const trackFilterSelect = useTrackFilterSelect()

  // Tracked before clearing: reset_click reports the filters that were selected.
  const handleClearFilters = () => {
    trackResetClick()
    clearAllFilters()
  }

  // Tracked after the store update: filter_select reads content_type from it (AssetTypeToggle).
  const handleSearchAllTypes = () => {
    setAssetType(ASSET_TYPE.ALL)
    rememberAssetType(ASSET_TYPE.ALL)
    trackFilterSelect(FILTER_NAME.PRODUCT_TYPE_TOGGLE, ASSET_TYPE.ALL, SELECTION_METHOD.MANUAL)
  }

  return (
    <div className="results-empty-state">
      <div className="results-empty-state__text">
        <h2 className="results-empty-state__title cgt-heading-300">
          {translate('search_page.results.empty_title')}
        </h2>
        <p className="results-empty-state__description cgt-body-md">
          {translate('search_page.results.empty_description')}
        </p>
      </div>
      {(hasFilters || isTypeSelected) && (
        <div className="results-empty-state__actions">
          {hasFilters && (
            <Button
              type="secondary"
              size="small"
              actionType="button"
              customClass="results-empty-state__action"
              onClick={handleClearFilters}
            >
              {translate('search_page.results.clear_filters')}
            </Button>
          )}
          {isTypeSelected && (
            <Button
              type="primary"
              size="small"
              actionType="button"
              customClass="results-empty-state__action"
              onClick={handleSearchAllTypes}
            >
              {translate('search_page.results.search_all_types')}
            </Button>
          )}
        </div>
      )}
      <div className="results-empty-state__promo">
        <PromoCards slot={PROMO_SLOT.EMPTY_STATE} />
      </div>
    </div>
  )
}

export default EmptyState
